import { render, staticRenderFns } from "./SenReadingDup.vue?vue&type=template&id=5b4e13f6&scoped=true&"
import script from "./SenReadingDup.vue?vue&type=script&lang=js&"
export * from "./SenReadingDup.vue?vue&type=script&lang=js&"
import style0 from "./SenReadingDup.vue?vue&type=style&index=0&id=5b4e13f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e13f6",
  null
  
)

export default component.exports